import { connectFeatureToggle } from 'platform/utilities/feature-toggles';
import { getScheduledDowntime } from 'platform/monitoring/DowntimeNotification/actions';
import createCommonStore from './store';
import startSitewideComponents from '../site-wide';

/**
 * Wrapper for creating a store and sitewide components, used across all apps
 *
 * @param {object} appInfo The UI and business logic of your React application
 * @param {string} appInfo.entryName The name of the app being built
 * @param {object} appInfo.reducer An object containing reducer functions. Will have
 * combineReducers run on it after being merged with the common, cross-site reducer.
 * @param {string} appInfo.url The base url for the React application
 * @param {array} appInfo.analyticsEvents An array which contains analytics events to collect
 * when the respective actions are fired.
 * @param {boolean} preloadScheduledDowntimes Whether to fetch scheduled downtimes.
 * @param {array} appInfo.additionalMiddlewares Array of additional Redux middlewares to include.
 */
export default function setUpCommonFunctionality({
  entryName,
  reducer,
  analyticsEvents,
  url,
  preloadScheduledDowntimes,
  additionalMiddlewares = [],
}) {
  // Set the app name for use in the apiRequest helper
  window.appName = entryName;

  const store = createCommonStore(
    reducer,
    analyticsEvents,
    additionalMiddlewares,
  );
  connectFeatureToggle(store.dispatch);

  if (preloadScheduledDowntimes) {
    const actionCreator = getScheduledDowntime();
    actionCreator(store.dispatch, store.getState());
  }

  if (url?.endsWith('/')) {
    throw new Error(
      'Root urls should not end with a slash. Check your manifest.json file and application entry file.',
    );
  }

  startSitewideComponents(store);

  return store;
}
